import ArrowLeft from "../../assets/icons/Arrow/ArrowLeft";
import { useRightPanel } from "../../context/RightPanelContext";
import { countQuantityCart } from "../../services/cartShoppingService";
import { RootState } from "../../store/store";
import ShoppingCartItem from "../ShoppingCartItem/ShoppingCartItem";
import "./RightPanel.scss";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const RightPanel = () => {
  const { shoppingCart } = useSelector((state: RootState) => state.cart);
  const { closePanel } = useRightPanel();
  const navigate = useNavigate();

  return (
    <div className="right-panel-container">
      <div className="overlay" onClick={closePanel} />
      <div className="right-panel">
        <h3>VOTRE PANIER</h3>
        {shoppingCart?.length > 0 ? (
          <div className="shopping-cart-items">
            {shoppingCart.map((item) => (
              <ShoppingCartItem
                key={item.productCode}
                code={item.productCode}
                quantity={item.quantity}
              />
            ))}
          </div>
        ) : (
          <div>Pas d'article dans le panier</div>
        )}
        <div className="recap-cart">
          <div>
            <span>{countQuantityCart(shoppingCart)} articles</span>
            <span>XX,XX €</span>
          </div>
          <div>
            <span>Livraison</span>
            <span>XX,XX €</span>
          </div>
          <span />
          <div>
            <span>Total (HT)</span>
            <span>XX,XX €</span>
          </div>
          <div>
            <span>Dont TVA</span>
            <span>XX,XX €</span>
          </div>
          <div>
            <span>Total (TTC)</span>
            <span>XX,XX €</span>
          </div>
        </div>
        <div className="action-cart">
          <button onClick={() => closePanel()}>
            <ArrowLeft /> Continuer mes achats
          </button>
          <button onClick={() => navigate("/order")}>Commander</button>
        </div>
      </div>
    </div>
  );
};

export default RightPanel;
